// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  resultPage: 'resultPage', // 储值结果页
  vipPage: 'vipPage', // vip页
  bankPage: 'bankPage', // 银行汇款页
  paymentCreditPage: 'paymentCreditPage', //信用卡独立支付页
  balancePage: 'balancePage', // 平台币余额页面
  balanceTopupPage: 'balanceTopupPage', // 平台币充值页面
  browserPay: 'browserPay', // 储值结果跳转页
  selectPage: 'selectPage' // 支付方式选择页
};

// 弹窗类型
export const popupType = {
  loginPopup: 'loginPopup', // 登录弹窗
  charPopup: 'charPopup', // 角色弹窗
  gameCouponPopup: 'gameCouponPopup', // 游戏优惠券弹窗
  vipCouponPopup: 'vipCouponPopup', // vip优惠券弹窗
  birthCouponPopup: 'birthCouponPopup', // 生日优惠券弹窗
  paytypeCouponPopup: 'paytypeCouponPopup', // 支付渠道优惠券弹窗
  eventlistPopup: 'eventlistPopup', // 福利弹窗
  aboutCurrencyPopup: 'aboutCurrencyPopup', // 关于代金币弹窗
  safariAddToHomePopup: 'safariAddToHomePopup', // safari添加到主屏幕弹窗
  couponUseCheckPopup: 'couponUseCheckPopup', // 优惠券使用确认弹窗
  pointCardPopup: 'pointCardPopup', // 点卡弹窗
  paytypeAreaPopup: 'paytypeAreaPopup', // 支付渠道区域弹窗
  productPopup: 'productPopup', // 商品选择弹窗
  errorPaytypePopup: 'errorPaytypePopup', // 支付渠道错误弹窗
  doubleSendPopup: 'doubleSendPopup', // 双倍券弹窗
  coinBalancePopup: 'coinBalancePopup', // 代金币余额不足弹窗
  quickPayCardSelectPopup: 'quickPayCardSelectPopup', // 选择支付卡弹窗
  cancelOrderConfirmPopup: 'cancelOrderConfirmPopup', // 取消订单确认弹窗
  leavePageConfirmPopup: 'leavePageConfirmPopup', // 离开页面确认弹窗
  removeCartProductPopup: 'removeCartProductPopup', // 移除购物车商品弹窗
  aboutBalancePopup: 'aboutBalancePopup', // 关于平台币弹窗
  pwaInstallPopup: 'pwaInstallPopup', // pwa安装弹窗
  pwaBindRolePopup: 'pwaBindRolePopup', // pwa绑定角色弹窗
  sharePopup: 'sharePopup', // 分享弹窗
  rightCenterPopup: 'rightCenterPopup', // 权益中心弹窗
  eventsRulePopup: 'eventsRulePopup', //限时活动规则弹窗
  eventsBagPopup: 'eventsBagPopup', //限时活动领取记录弹窗
  confirmRolePopup: 'confirmRolePopup' //限时活动确认领取角色弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType,
  accountInfo: 'account_info', // 帐号信息模块
  paytypeSection: 'select_channels', // 选择支付渠道模块
  eventList: 'event_list', // 活动列表弹窗
  mainBar: 'mainbar', // 主页功能入口
  areaLimit: 'change_regions', //切换地区弹窗
  areaLimitConfirm: 'confirm_regions' //确定地区弹窗
};

/**
    页面展示
    key: 页面类型key
*/
export const viewPage = key => {
  window?.sdkstoreDataLayer?.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
    弹窗展示
    popupType: 描述弹窗类型
*/
export const showPopup = key => {
  window?.sdkstoreDataLayer?.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
    按钮点击
    btnName: 按钮名称
    reason: 按钮所属模块
*/
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window?.sdkstoreDataLayer?.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};
